module.exports = __webpack_public_path__ + "img/revox.475401e8.svg";